export const WAITING = 'WAITING';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';

const isPromise = (value) => {
  return typeof value === 'object' && typeof value.then === 'function';
};

export default ({ dispatch }) =>
  (next) =>
  (action) => {
    if (!action.payload || action.payload.promised || !isPromise(action.payload)) {
      return next(action);
    }

    const { type } = action;

    next({
      ...action,
      promised: true,
      type: `${type}_${WAITING}`,
    });

    return action.payload
      .then((value) => {
        const resolved = {
          ...action,
          promised: true,
          payload: value,
          type: `${type}_${SUCCESS}`,
        };

        dispatch(resolved);

        return {
          value,
          action: resolved,
        };
      })
      .catch((error) => {
        if (process.env.NODE_ENV === 'development') {
          console.error(error);
        }

        dispatch({
          ...action,
          promised: true,
          payload: error,
          type: `${type}_${ERROR}`,
        });

        return error;
      });
  };
